import {Fragment, h} from "preact";
import {ButtonPrimaryHighlight} from '../buttons/buttons'
import ModalHelp from '../../../home/HelpSection/ModalHelp/ModalHelp'
import { useState } from 'preact/hooks'
import './card-dashboard-styles.scss'
import {isMobileAgent} from "../../common";

export default function CardHelp ({fullWidth, className, id}) {
    const [openModal, setOpenModal] = useState(false)
    return (
        <div id={id} className={`card-dashboard-help inverse
            ${fullWidth && isMobileAgent() ? 'card-dashboard-full-width' : 'card-dashboard'}
            ${className}
        `}>
            {openModal && <ModalHelp visible={openModal} onClose={() => setOpenModal(false)} />}
            <div>
                <div className='card-dashboard__header'><p>¿Necesitas ayuda?</p></div>
                <div className='card-dashboard__content desktop-only'>Reserva una cita y te llamaremos. ¡Estamos a tu disposición!</div>
                <ButtonPrimaryHighlight className='full-width m-top-half' onClick={() => setOpenModal(true)}>Reservar Cita</ButtonPrimaryHighlight>
            </div>
        </div>
    )
}
